export default "__VITE_ASSET__84b7402f__"